import React, { Component } from 'react';
import OpeningHours from '../OpeningHours';
import i18n from 'utils/translate';
import Address from '../Address';
import Person from '../Person';
import AdditionalInRegion from '../AdditionalInRegion';
import Languages from '../Languages';

const defaultProps = {
  office: null,
  onCommunityClick: () => {},
  onRegionClick: () => {}
};

class Office extends Component {
  render() {
    const { office } = this.props;
    const person1 = office.leadPerson1.name == null ? false : true;
    const person2 = office.leadPerson2.name == null ? false : true;
    const person3 = office.leadPerson3.name == null ? false : true;
    const displayHours = office.openingHours.mon === '' ? false : true;
    const advisors = office.advisors ? true : false;
    let officeInfoClass = 'col-sm-7 office__info ';
    if (person1 === false && person2 === false && person3 === false) {
      officeInfoClass = 'col-sm-7 office__info no-border';
    }
    return (
      <article className="office">
        <div className="row office__intro-card">
          <div className={`${officeInfoClass}`}>
            <div className="row office__info-top">
              <div className="col-sm-4">
                <div
                  className="office__image"
                  data-responsive-background-image
                  style={{ backgroundImage: `url(${office.image ? office.image : ''})` }}
                >
                  <img className="img-responsive" src={office.image ? office.image : ''} alt={office.title} />
                </div>
              </div>
              <div className="col-sm-8 office__center-title-wrap">
                <div>{i18n('office')}</div>
                <h2 className="office__center-title">
                  <a href={office.detailUrl}>{office.title}</a>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <Address
                  contacts={office.contacts}
                  address={office.address}
                  lat={office.lat}
                  lon={office.lon}
                ></Address>
              </div>
              <div className="col-sm-6 hidden-xs">
                {displayHours && <OpeningHours openingHours={office.openingHours}></OpeningHours>}
              </div>
            </div>
            <div className="row hidden-xs">
              <div className="col-xs-12">
                <AdditionalInRegion
                  region={office.address}
                  onCommunityClick={this.props.onCommunityClick}
                  onRegionClick={this.props.onRegionClick}
                  headline={i18n('other-offices')}
                ></AdditionalInRegion>
              </div>
            </div>
            <div className="office__info-mobile visible-xs">
              <div className="collapse" id={`more-info-${office.id}`}>
                {displayHours && <OpeningHours openingHours={office.openingHours}></OpeningHours>}
                {(person1 || person2 || person3) && (
                  <b className="head office__lead-persons-header">{i18n('lead-persons-header')}</b>
                )}
                {person1 && <Person person={office.leadPerson1}></Person>}
                {person2 && <Person person={office.leadPerson2}></Person>}
                {person3 && <Person person={office.leadPerson3}></Person>}
                <Languages languages={office.languages} headline={i18n('languages')}></Languages>
                <div className="row row-no-gutters">
                  <div className="col-xs-12">
                    <AdditionalInRegion
                      region={office.address}
                      onCommunityClick={this.props.onCommunityClick}
                      onRegionClick={this.props.onRegionClick}
                      headline={i18n('other-offices')}
                    ></AdditionalInRegion>
                  </div>
                </div>
                <div className="row row-no-gutters">
                  <div className="col-sm-12 text-right office__advisors">
                    {advisors && (
                      <a className="pull-right" href={office.detailUrl + '#advisors'}>
                        {i18n('find-advisor')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <a
                className="show-more collapsed"
                role="button"
                data-toggle="collapse"
                href={`#more-info-${office.id}`}
                aria-expanded="false"
                aria-controls="more-info"
              >
                <span className="more">
                  {' '}
                  {i18n('more')} <i className="icon-nav-arrow"></i>
                </span>
                <span className="less">
                  {' '}
                  {i18n('less')} <i className="icon-nav-arrow"></i>
                </span>
              </a>
            </div>
          </div>
          <div className="col-sm-5 hidden-xs">
            <div>
              {(person1 || person2 || person3) && (
                <div className="office__leader-title">{i18n('lead-persons-header')}</div>
              )}
              {person1 && <Person person={office.leadPerson1}></Person>}
              {person2 && <Person person={office.leadPerson2}></Person>}
              {person3 && <Person person={office.leadPerson3}></Person>}
              <Languages languages={office.languages} headline={i18n('languages')}></Languages>
            </div>
            <div className="row row-no-gutters office__advisors">
              <div className="col-sm-12 text-right">
                {advisors && (
                  <a className="pull-right" href={office.detailUrl + '#advisors'}>
                    {i18n('find-advisor')}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </article>
    );
  }

  getOfficePersons() {
    const { office } = this.props;
    const persons = [];
    if (office) {
      if (office.leadPerson1) persons.push(office.leadPerson1);
      if (office.leadPerson2) persons.push(office.leadPerson2);
      if (office.leadPerson3) persons.push(office.leadPerson3);
    }
    return persons;
  }
}

Office.defaultProps = defaultProps;

export default Office;
